
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/faq",
      function () {
        return require("private-next-pages/[market]/[language]/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/faq"])
      });
    }
  